import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

/**
 * iter196 — Visibilité des données métier pilotée UNIQUEMENT par les droits (crm.voir_*) ;
 * œil réservé aux secrets techniques (Super-admin). Affichage seul, aucune donnée altérée.
 */
export const MASK = "••••••";
let vis = { montants: true, ca: true, remises: true, coordonnees: true, marge: true };
export const setVisibilityFromUser = (user) => {
  const acts = user?.rights?.crm?.actions || [];
  const has = (k) => !user || !!user.is_first_admin || acts.includes(k);
  vis = { montants: has("voir_montants"), ca: has("view_financial_totals"), remises: has("voir_remises"), coordonnees: has("voir_coordonnees"), marge: has("voir_marge") };
};
export const canSee = (kind) => !!vis[kind];
export const mask = (v, kind = "montants") => (vis[kind] ? v : MASK);

/** Donnée métier sensible : •••••• si le droit de visibilité correspondant est absent (ou valeur masquée par l'API). */
export function Vis({ kind = "coordonnees", children, className, style, testId }) {
  const hidden = !vis[kind] || children == null || children === "";
  return <span className={className} style={style} data-testid={testId} data-masked={hidden && !vis[kind]}>{hidden ? (vis[kind] ? "—" : MASK) : children}</span>;
}

/** Secret technique (B2 / NAS / Domaine) : masqué par défaut ; œil de révélation uniquement pour le Super-admin. */
export function Secret({ value, superAdmin = false, testId, mono = true }) {
  const [show, setShow] = useState(false);
  const has = value != null && value !== "";
  return (
    <span className="inline-flex items-center" style={{ gap: 6, minWidth: 0 }} data-testid={testId} data-revealed={show}>
      <span className="truncate" style={{ fontFamily: mono ? "Consolas, monospace" : undefined, fontSize: 12, color: show ? "#e8e8ec" : "#8a8a92", letterSpacing: show ? 0 : ".08em" }}>{!has ? "—" : show ? value : MASK}</span>
      {superAdmin && has && <button type="button" onClick={() => setShow((v) => !v)} className="inline-flex items-center justify-center shrink-0" title={show ? "Masquer" : "Révéler (Super-admin)"} aria-pressed={show}
        style={{ width: 22, height: 22, borderRadius: 6, border: `0.5px solid ${show ? "#E0822E" : "#2e2e34"}`, background: show ? "#E0822E22" : "#18181c", color: show ? "#E0822E" : "#a9a9b2" }} data-testid={testId ? `${testId}-eye` : undefined}>{show ? <EyeOff size={12} /> : <Eye size={12} />}</button>}
    </span>
  );
}
